import React, { useState, useEffect, useCallback } from 'react'
import { subDays, parseToDate, dateToBR } from 'utils/date'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { requestReportPaymentsRange } from 'requests/reports'
import { InfoPage } from 'templates/InfoPage'
import { Card } from 'ui-components/Card'
import { RequestButton } from 'components/RequestButton';
import { SideMenu } from 'components/SideMenu'
import { InputDate } from 'components/Form/components'
import { BarChart } from './components/BarChart'
import { Totals } from './components/Totals'
import {
  Chart,
  SearchForm,
  ButtonContainer,
  Tip,
} from './styles';

const END_DATE = new Date()
const START_DATE = subDays(END_DATE, 30)

const INITIAL_VALUES = {
  start_date: START_DATE,
  end_date: END_DATE,
}

export default function ReceiptsReport() {
  const [filters, setFilters] = useState(INITIAL_VALUES)
  const [report, setReport] = useState()
  const [loading, setLoading] = useState()
  const [totals, setTotals] = useState()

  const getReport = useCallback(async (dates) => {
    setLoading(true)
    const response = await requestReportPaymentsRange(dates)

    setLoading(false)
    setFilters({
      start_date: parseToDate(response.attributes.start_date),
      end_date: parseToDate(response.attributes.end_date),
    })

    const reportData = response.attributes.report
    const data = Object.keys(response.attributes.report).map((key) => {
      const item = reportData[key]

      return {
        ...item,
        name: dateToBR(parseToDate(key)),
        total: Number(item.total),
        total_discount: Number(item.total_discount) * -1,
      }
    })

    setReport(data)
    setTotals(response.attributes.totals)
  }, [])

  useEffect(() => {
    getReport(INITIAL_VALUES)
  }, [getReport])

  const onChange = (params) => {
    const { datetime, name } = params

    setFilters({
      ...filters,
      [name]: datetime,
    })
  }

  const onSearch = () => {
    getReport(filters)
  }

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  return (
    <InfoPage
      renderMenu={renderMenu}
      title="Recebimentos"
      subtitle=""
    >
      <Card>
        <Tip>
          Período máximo de 6 meses
        </Tip>
        <SearchForm>
          <InputDate
            value={filters.start_date}
            label="Data inicial"
            id="start_date"
            name="start_date"
            onChange={onChange}
          />

          <InputDate
            value={filters.end_date}
            label="Data final"
            id="end_date"
            name="end_date"
            onChange={onChange}
          />

          <ButtonContainer>
            <RequestButton
              onClick={onSearch}
              color="primary"
              loading={loading}
              text="Buscar"
            />
          </ButtonContainer>
        </SearchForm>

        <Chart>
          <BarChart report={report} />
        </Chart>
      </Card>

      <Totals totals={totals} />
    </InfoPage>
  )
}
